export const MCP_OAUTH_ORIGIN = window.location.origin;
const CALLBACK_PATH = '/oauth-callback';
export const MCP_OAUTH_CALLBACK_URL = `${MCP_OAUTH_ORIGIN}${CALLBACK_PATH}`;
